import update from 'immutability-helper';

import {
  SELECT_PROJECT,
  ROLLBACK_PROJECT,
} from 'store/services/project/actionTypes';
import { GET_DICTIONARY_REQUEST } from 'store/services/dictionaries/actionTypes';

import * as types from './actionTypes';
import initialState from './initialState';

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_DICTIONARY_ENTRIES_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_DICTIONARY_ENTRIES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          paginationOptions: action.payload.paginationOptions,
          isLoading: false,
          data: {
            ...state.list.data,
            items:
              action.payload.paginationOptions.page > 1
                ? [
                    ...state.list.data.items,
                    ...action.payload.dictionaryEntries,
                  ]
                : action.payload.dictionaryEntries,
            count: action.payload.count,
          },
        },
      };
    case types.GET_DICTIONARY_ENTRIES_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.ADD_DICTIONARY_ENTRY_REQUEST:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: true,
        },
      };
    case types.ADD_DICTIONARY_ENTRY_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
        },
      };
    case types.ADD_DICTIONARY_ENTRY_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_DICTIONARY_ENTRY_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: true,
        },
      };
    case types.UPDATE_DICTIONARY_ENTRY_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: false,
        },
      };
    case types.UPDATE_DICTIONARY_ENTRY_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.DELETE_DICTIONARY_ENTRY_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: true,
        },
      };
    case types.DELETE_DICTIONARY_ENTRY_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
        },
        list: {
          ...state.list,
          data: {
            ...state.list.data,
            selected: action.payload.selected,
          },
        },
      };
    case types.DELETE_DICTIONARY_ENTRY_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.DELETE_DICTIONARY_ENTRIES_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: true,
        },
      };
    case types.DELETE_DICTIONARY_ENTRIES_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
        },
        list: {
          ...state.list,
          data: {
            ...state.list.data,
            selected: [],
          },
        },
      };
    case types.DELETE_DICTIONARY_ENTRIES_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_SELECTED_ENTRIES:
      return {
        ...state,
        list: {
          ...state.list,
          data: {
            ...state.list.data,
            selected: action.payload.entries,
          },
        },
      };
    case types.UPDATE_DICTIONARY_ENTRIES_PAGINATION_PARAMS:
      return {
        ...state,
        list: {
          ...state.list,
          paginationOptions: action.payload.paginationOptions,
        },
      };
    case types.SORT_DICTIONARY_ENTRIES:
      return update(state, {
        list: {
          paginationOptions: {
            $set: action.payload.paginationOptions,
          },
          isLoading: {
            $set: true,
          },
          error: {
            $set: '',
          },
          data: {
            items: {
              $set: [],
            },
            count: {
              $set: 0,
            },
            selected: {
              $set: [],
            },
          },
        },
      });
    case GET_DICTIONARY_REQUEST:
    case SELECT_PROJECT:
    case ROLLBACK_PROJECT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
